import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KendoEditor = _resolveComponent("KendoEditor")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-editor", {'disabledpage' : _ctx.localIsReadOnly}])
  }, [
    _createVNode(_component_KendoEditor, {
      ref: "editor",
      tools: _ctx.tools,
      style: _normalizeStyle(_ctx.GetEditorInlineStyle()),
      readonly: _ctx.localIsReadOnly,
      resizable: _ctx.isResizable,
      "extend-view": _ctx.ExtendView,
      value: _ctx.localText,
      "paste-html": _ctx.HandlePaste,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.OnChange($event))),
      onLoaded: _ctx.OnEditorLoaded,
      onExecute: _ctx.OnExecute
    }, null, 8, ["tools", "style", "readonly", "resizable", "extend-view", "value", "paste-html", "onLoaded", "onExecute"])
  ], 2))
}